// /home/vitruvio/puntum-frontend/src/services/api.js

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api-dev.puntum.cl'

export async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem('puntum_token')
  
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...options.headers
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers
    })

    if (response.status === 401) {
      console.warn(`[API 401] Sesión no autorizada o expirada en ${endpoint}`)
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(errorData.detail || `Error HTTP: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.warn(`[API] Solicitud a ${endpoint} no completada. Se aplicará comportamiento defensivo local.`, error.message)
    throw error
  }
}